export const environment = {
      production: true,
      jiraAPI  :  'https://jira.bna.com/rest/api/2/',
      issuer   : 'https://bna.okta.com' ,
    //  clientId : '0oasktmqdjZNdYTav0x7'    // EJourney-Q
      //  clientId : '0oasl40e82lQzCshD0x7'    // EJourney-D
       clientId : '0oasl41nedmjyf7Az0x7'    // EJourney
};
